// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.worktime-datepicker {
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont;
  width: 100%;
  border: none;
  overflow: hidden;
}
.worktime-datepicker .has-daybookings {
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  text-align: center;
  background: #ff9900;
  margin-left: auto;
  margin-right: auto;
  margin-top: 3px;
}
.worktime-datepicker .react-datepicker__navigation--previous {
  left: 80px;
}
.worktime-datepicker .react-datepicker__navigation--next {
  right: 80px;
}
.worktime-datepicker .react-datepicker__navigation-icon {
  top: 3px;
}
.worktime-datepicker .react-datepicker__header {
  background-color: transparent;
  border-bottom: 1px solid var(--palette-gray-dark);
}
.worktime-datepicker .react-datepicker__header .react-datepicker__current-month {
  margin: 0;
  text-transform: capitalize;
  font-weight: bold;
  font-size: 22px;
  line-height: 1.2;
  letter-spacing: -0.00833em;
  color: var(--palette-primary-dark);
  text-align: center;
}
.worktime-datepicker .react-datepicker__header .react-datepicker__day-names {
  margin-right: 0px;
}
.worktime-datepicker .react-datepicker__header .react-datepicker__day-name {
  color: var(--palette-primary-dark);
  font-size: small;
  letter-spacing: 1px;
  margin-left: 0;
}
.worktime-datepicker .react-datepicker__month-container {
  width: 100%;
}
.worktime-datepicker .react-datepicker__week {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.worktime-datepicker .react-datepicker__day {
  color: var(--palette-primary-dark);
  width: 50px;
  height: 57px;
  border: 1px solid var(--palette-gray-dark);
  border-radius: 5px;
  overflow: hidden;
}
.worktime-datepicker .react-datepicker__day--selected {
  background-color: var(--palette-green-main);
  border-color: var(--palette-green-main);
  color: var(--palette-white-main);
}
.worktime-datepicker .react-datepicker__day--selected .worktime-datepicker-hours {
  color: var(--palette-white-main);
}
.worktime-datepicker .react-datepicker__day--selected .worktime-datepicker-hours.planned {
  color: var(--palette-white-main);
}
.worktime-datepicker .worktime-datepicker-hours {
  color: var(--palette-green-main);
  font-size: 12px;
  font-weight: 700;
  margin: 0;
  line-height: normal;
}
.worktime-datepicker .worktime-datepicker-hours.planned {
  color: var(--palette-blue-main);
}
.worktime-datepicker .worktime-datepicker-hours.planned.compact {
  font-weight: 400;
}
@media (min-width: 451px) {
  .worktime-datepicker .react-datepicker__day-name {
    width: 39px;
    margin-right: 14px;
  }
  .worktime-datepicker .react-datepicker__day-name:first-child {
    width: 30px;
  }
}
@media (max-width: 450px) {
  .worktime-datepicker .react-datepicker__header .react-datepicker__day-names {
    display: flex;
    justify-content: space-between;
  }
  .worktime-datepicker .react-datepicker__week {
    justify-content: space-between;
  }
  .worktime-datepicker .react-datepicker__day-name {
    width: calc((100vw - 32px - 7 * 2px) / 8);
    min-width: 28px;
    margin-right: 2px;
  }
  .worktime-datepicker .react-datepicker__day-name:first-child {
    width: calc((100vw - 32px - 7 * 2px) / 8);
    min-width: 20px;
  }
  .worktime-datepicker .react-datepicker__day {
    width: calc((100vw - 32px - 7 * 2px) / 8);
    min-width: 28px;
  }
  .worktime-datepicker .react-datepicker__week-number {
    width: calc((100vw - 32px - 7 * 2px) / 8);
    min-width: 20px;
    text-align: center;
  }
  .worktime-datepicker .react-datepicker__navigation--previous {
    left: 40px;
  }
  .worktime-datepicker .react-datepicker__navigation--next {
    right: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./cssSource/less/calendar.less"],"names":[],"mappings":"AAGA;EACE,wDAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAFF;AAFA;EAOI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAFJ;AAbA;EAmBI,UAAA;AAHJ;AAhBA;EAuBI,WAAA;AAJJ;AAnBA;EA2BI,QAAA;AALJ;AAtBA;EA+BI,6BAAA;EACA,iDAAA;AANJ;AA1BA;EAmCM,SAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;EACA,kBAAA;AANN;AApCA;EA8CM,iBAAA;AAPN;AAvCA;EAkDM,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AARN;AA7CA;EA0DI,WAAA;AAVJ;AAhDA;EA8DI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAXJ;AAtDA;EAqEI,kCAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;AAZJ;AA9DA;EA8EI,2CAAA;EACA,uCAAA;EACA,gCAAA;AAbJ;AAnEA;EAkFM,gCAAA;AAZN;AAaM;EACE,gCAAA;AAXR;AAzEA;EA0FI,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AAdJ;AAgBI;EACE,+BAAA;AAdN;AAgBM;EACE,gBAAA;AAdR;AAqBA;EACE;IAKI,WAAA;IACA,kBAAA;EAvBJ;EAmBI;IACE,WAAA;EAjBN;AACF;AAyBA;EACE;IAGM,aAAA;IACA,8BAAA;EAzBN;EAqBA;IASI,8BAAA;EA3BJ;EAkBA;IAiBI,yCAAA;IACA,eAAA;IACA,iBAAA;EAhCJ;EA0BI;IACE,yCAAA;IACA,eAAA;EAxBN;EASA;IAuBI,yCAAA;IACA,eAAA;EA7BJ;EAKA;IA4BI,yCAAA;IACA,eAAA;IACA,kBAAA;EA9BJ;EAAA;IAkCI,UAAA;EA/BJ;EAHA;IAsCI,WAAA;EAhCJ;AACF","sourcesContent":["@import \"variables\";\n// @import \"~@mui/icons-material\";\n\n.worktime-datepicker {\n  font-family:'Roboto', -apple-system, BlinkMacSystemFont;\n  width: 100%;\n  border: none;\n  overflow: hidden;\n\n  .has-daybookings {\n    width: 24px;\n    height: 24px;\n    line-height: 24px;\n    border-radius: 50%;\n    text-align: center;\n    background: #ff9900;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 3px;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 80px;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 80px;\n  }\n\n  .react-datepicker__navigation-icon {\n    top: 3px;\n  }\n\n  .react-datepicker__header {\n    background-color: transparent;\n    border-bottom: 1px solid var(--palette-gray-dark);\n\n    .react-datepicker__current-month {\n      margin: 0;\n      text-transform: capitalize;\n      font-weight: bold;\n      font-size: 22px;\n      line-height: 1.2;\n      letter-spacing: -0.00833em;\n      color: var(--palette-primary-dark);\n      text-align: center;\n    }\n\n    .react-datepicker__day-names {\n      margin-right: 0px;\n    }\n\n    .react-datepicker__day-name {\n      color: var(--palette-primary-dark);\n      font-size: small;\n      letter-spacing: 1px;\n      margin-left: 0;\n    }\n  }\n\n  .react-datepicker__month-container {\n    width: 100%;\n  }\n\n  .react-datepicker__week {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n  }\n\n  .react-datepicker__day {\n    color: var(--palette-primary-dark);\n    width: 50px;\n    height: 57px;\n    border: 1px solid var(--palette-gray-dark);\n    border-radius: 5px;\n    overflow: hidden;\n  }\n\n  .react-datepicker__day--selected {\n    background-color: var(--palette-green-main);\n    border-color: var(--palette-green-main);\n    color: var(--palette-white-main);\n    .worktime-datepicker-hours {\n      color: var(--palette-white-main);\n      &.planned {\n        color: var(--palette-white-main);\n      }\n    }\n  }\n\n  .worktime-datepicker-hours {\n    color: @colorGreen;\n    font-size: 12px;\n    font-weight: 700;\n    margin: 0;\n    line-height: normal;\n\n    &.planned {\n      color: @colorBlue;\n      \n      &.compact {\n        font-weight: 400;\n      }\n    }\n  }\n}\n\n// Styles for wider screens (desktop/tablet)\n@media (min-width: 451px) {\n  .worktime-datepicker {\n    .react-datepicker__day-name {\n      &:first-child{\n        width: 30px;\n      }\n      width: 39px;\n      margin-right: 14px;\n    }\n  }\n}\n\n// Styles for narrow screens (mobile)\n@media (max-width: 450px) {\n  .worktime-datepicker {\n    .react-datepicker__header {\n      .react-datepicker__day-names {\n        display: flex;\n        justify-content: space-between;\n      }\n    }\n\n    .react-datepicker__week {\n      justify-content: space-between;\n    }\n\n    .react-datepicker__day-name {\n      &:first-child{\n        width: calc((100vw - 32px - 7 * 2px) / 8);\n        min-width: 20px;\n      }\n      width: calc((100vw - 32px - 7 * 2px) / 8);\n      min-width: 28px;\n      margin-right: 2px;\n    }\n    \n    .react-datepicker__day {\n      width: calc((100vw - 32px - 7 * 2px) / 8);\n      min-width: 28px;\n    }\n    \n    .react-datepicker__week-number {\n      width: calc((100vw - 32px - 7 * 2px) / 8);\n      min-width: 20px;\n      text-align: center;\n    }\n    \n    .react-datepicker__navigation--previous {\n      left: 40px;\n    }\n\n    .react-datepicker__navigation--next {\n      right: 40px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
